export const ERROR_INVALID_DATE = 'ERROR_INVALID_DATE';
export const ERROR_POD = 'ERROR_POD';
export const ERROR_POD_DATE = 'ERROR_POD_DATE';
export const PROPERTY_RESTRICTED = 'PROPERTY_RESTRICTED';
